import { cn } from "@/lib/utils";

interface TeamAvatarProps {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  showFrame?: boolean;
  /** Pre-rendered circular portrait (e.g. from design export) — show as-is, no extra clip/ring */
  intrinsic?: boolean;
}

/** Team portrait — standard members use a circular frame; intrinsic photos render unchanged */
export function TeamAvatar({
  src,
  alt,
  className,
  imageClassName,
  showFrame = true,
  intrinsic = false,
}: TeamAvatarProps) {
  if (intrinsic) {
    return (
      <img
        src={src}
        alt={alt}
        width={512}
        height={512}
        className={cn("mx-auto mb-5 block h-auto w-44 shrink-0", className, imageClassName)}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return (
    <div
      className={cn(
        "relative mx-auto mb-5 h-36 w-36 shrink-0 overflow-hidden rounded-full",
        showFrame && "bg-white ring-1 ring-border/90 shadow-[0_2px_8px_rgba(0,0,0,0.06)]",
        className
      )}
    >
      <img
        src={src}
        alt={alt}
        className={cn("h-full w-full object-contain object-center", imageClassName)}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
